<!--资环行动-详情页-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="act" :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class="box-width newsDetail">
        <h4>{{ informationDetail.title }}</h4>
        <span class="time">{{ informationDetail.releaseTime }}</span>
        <span class="name" style="margin-left: 10px;">{{ informationDetail.author }}</span>
      </div>
      <!--内容-->
      <div v-html="replaceContent(informationDetail.content)" class="htmlImgSize box-width"></div>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <div class="box-width mobileDetail">
          <h4 >{{ informationDetail.title }}</h4>
          <span class="time">{{ informationDetail.releaseTime }}</span>
          <span class="name" style="margin-left: 10px;">{{ informationDetail.author }}</span>
        </div>
        <!--内容-->
        <div v-html="replaceContent(informationDetail.content)" class="htmlImgSize"></div>

        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import { findInformationOne } from '@/api/zh'

export default {
  data () {
    return {
      components: {
        tail: header,
        tail1: footer
      },
      informationDetail: {},
      informationId: null
    }
  },
  created () {
    this.informationId = this.$route.query.informationId
  },
  mounted () {
    this.getInformatioDetail()
  },
  methods: {
    async getInformatioDetail () {
      const res = await findInformationOne(this.informationId)
      if (res.code === 200) {
        this.informationDetail = res.data
      }
    },
    replaceContent (content) {
      return content.replace(/http:\/\/8\.155\.44\.137:9000\/zihuan\//g, 'https://gdlsfw.com/zihuan/');
    }
  }

}
</script>

<style scoped>
::v-deep .htmlImgSize img{
  max-width: 100%;
  height: auto;
  background: transparent;
}
</style>
